module.exports = __webpack_public_path__ + "img/translator_ch-en.3e89049.svg";